var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "wxEditor" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.quillUpdateImg,
            expression: "quillUpdateImg",
          },
        ],
        attrs: { "element-loading-text": "请稍等，图片上传中" },
      },
      [
        _c("el-upload", {
          staticClass: "avatar-uploader",
          attrs: {
            action: _vm.serverUrl,
            "before-upload": _vm.beforeUpload,
            data: _vm.uploadData,
            headers: _vm.header,
            "on-error": _vm.uploadError,
            "on-success": _vm.uploadSuccess,
            "show-file-list": false,
            name: "file",
          },
        }),
        _c("quill-editor", {
          ref: "myQuillEditor",
          staticClass: "editor",
          attrs: { options: _vm.editorOption },
          on: {
            blur: function ($event) {
              return _vm.onEditorBlur($event)
            },
            change: function ($event) {
              return _vm.onEditorChange($event)
            },
            focus: function ($event) {
              return _vm.onEditorFocus($event)
            },
          },
          model: {
            value: _vm.content,
            callback: function ($$v) {
              _vm.content = $$v
            },
            expression: "content",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }